module.exports = __webpack_public_path__ + "img/listwy-progowe.b86dda25.jpg";